export default defineNuxtRouteMiddleware(async (to, from) => {

    const siteSlug = to.params.site_slug;
    const publicSiteData = useState('publicSiteData', () => null);
    const checkedSiteSlug = useState('checkedOrgSlug', () => null);

    // Only check if org_slug has changed or not checked yet //
    if (checkedSiteSlug.value === siteSlug && publicSiteData.value) {
        return;
    }

    // Skip on server
    if (process.env.NUXT_SKIP_SERVER_MIDDLEWARES === 'true' && process.server) {
        return;
    }

    try {
        const config = useRuntimeConfig();
        const { data } = await useFetch(`${config.public.apiUrl}/${siteSlug}/public-site-data`);
        publicSiteData.value = data.value.data;
        checkedSiteSlug.value = siteSlug;
    }
    catch(e) {
        console.log(e);
        // Show 400 error page on fetch failure
        throw createError({
            statusCode: 400,
            statusMessage: 'Bad Request'
        });
    }

});
